export const formatReadTime = timeToRead => `${timeToRead} ${timeToRead === 1 ? 'min' : 'mins'} read`;
